import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function PrivateRoute({ children }) {
  //const { data,error } = useSelector((state) => state.signIn);
  const authDataStr = localStorage.getItem('auth_data') || sessionStorage.getItem('auth_data');
  //console.log("PrivateRoute authDataStr : ", authDataStr);
  const parseAuthData = JSON.parse(authDataStr);

  // if (!parseAuthData?.token || (parseAuthData?.expiryTime && new Date(parseAuthData?.expiryTime) < new Date())) {
  //   return <Navigate to="/login" />;
  // }
  
  // Otherwise, render the children (protected page)
  return children;
}
